import { render, staticRenderFns } from "./NuHomeCloneProductCarousel.vue?vue&type=template&id=4d0ce570&scoped=true&"
import script from "./NuHomeCloneProductCarousel.vue?vue&type=script&lang=js&"
export * from "./NuHomeCloneProductCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NuHomeCloneProductCarousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NuHomeCloneProductCarousel.vue?vue&type=style&index=1&id=4d0ce570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ce570",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Carousel: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Carousel.vue').default})
